function handleOneTimeChange(event) {
  const oneTimeRadio = event.target;
  const sellingPlanInput = document.getElementById('selling_plan');
  const otPurchase = document.getElementById('otPurchase')
  const subPurchase = document.getElementById('subPurchase')

  if (oneTimeRadio.checked) {
    sellingPlanInput.value = '';
    otPurchase.classList.add('active')
    subPurchase.classList.remove('active')
  }
}

function handleSubscriptionChange(event) {
    const subscriptionRadio = event.target;
    const subscriptionWidgetContainer = document.querySelector('.subscription_widget__container');
    const sellingPlanSelect = subscriptionWidgetContainer.querySelector('#subscriptionPlan');
    const sellingPlanInput = document.getElementById('selling_plan');
    const otPurchase = document.getElementById('otPurchase')
    const subPurchase = document.getElementById('subPurchase')

    if (subscriptionRadio.checked) {
        sellingPlanInput.value = sellingPlanSelect.options[sellingPlanSelect.selectedIndex].value;
        otPurchase.classList.remove('active')
        subPurchase.classList.add('active')
    }
}

function handleSellingPlanChange(event) {
    const sellingPlanSelect = event.target;
    const subscriptionRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
    const sellingPlanInput = document.getElementById('selling_plan');
    const subscriptionPrice = document.querySelector('.subscribe__price')
    const subscriptionSave = document.querySelector('.subscription__save')

    if (subscriptionRadio.checked && subscriptionPrice) {
        sellingPlanInput.value = sellingPlanSelect.value;
        const optionSelected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex]
        subscriptionPrice.textContent = optionSelected.dataset.price
        subscriptionSave.textContent = optionSelected.dataset.discount
    }
}